import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX Tasks API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_TASKS_API_ENDPOINTS = {
  listDexTasks: {
    generated: 'apiControllerGetTasks',
    method: 'get',
    path: '/web/tasks/:vaultId/:all/:limit/:page',
  },
  getDexTask: {
    generated: 'apiControllerGetTask',
    method: 'get',
    path: '/web/task/:taskId',
  },
  createDexTask: {
    generated: 'apiControllerAddTask',
    method: 'post',
    path: '/web/add_task/:vaultId',
  },
  updateDexTask: {
    generated: 'apiControllerUpdateTask',
    method: 'put',
    path: '/web/update_task/:taskId',
  },
  updateDexTaskStatus: {
    generated: 'apiControllerUpdateTaskStatus',
    method: 'put',
    path: '/web/update_status_task/:taskId/:action',
  },
  deleteDexTask: {
    generated: 'apiControllerDeleteTask',
    method: 'delete',
    path: '/web/delete_task/:taskId',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexTasksEndpointName = keyof typeof DEX_TASKS_API_ENDPOINTS;
